<template>
  <div class="client-contact-actions">
    <div class="listing-title">{{ $t('clientContacts.listing.filters.all') }}</div>
    <div class="search">
      <tol-type-ahead
        :search-params="{
          url: `/client-contact/list?activeInactive=${activeInactive}&sortBy=${sortBy}
              &sortDirection=${sortDirection}&recordsPerPage=${recordsPerPage}&offset=${offSet}`,
          searchKeys: ['searchParam']
        }"
        :results-in-dropdown="false"
        :allow-empty-search="true"
        @filtered="onFiltered($event)"
      >
      </tol-type-ahead>
    </div>
    <div class="export">
      <router-link to="/client-contacts/create">
        <TolAltButton icon-name="plus" label="New Client Contact" />
      </router-link>
      <TolAltButton
        v-click-outside="() => (showSettingsDropdown = false)"
        icon-name="file-excel"
        label="Export to Excel"
        @click="toggleDropdown"
      />
      <Dropdown
        v-show="showSettingsDropdown"
        :menu-items="[
          { label: $t('clientContacts.listing.actions.exportAll') },
          { label: $t('clientContacts.listing.actions.exportPage') }
        ]"
        class="dropdown-menu-right"
        @optionClicked="onExportChange($event)"
      />
    </div>
  </div>
</template>

<script>
import TolAltButton from '@/app/components/TolAltButton';
import vClickOutside from 'v-click-outside';
import Dropdown from '@/app/components/Dropdown';
import TolTypeAhead from '@/app/components/TolTypeAhead';
import {
  ClientContactsListingActions,
  ClientContactsListingGetters
} from '../client-contacts-listing.keys';
export default {
  components: {
    TolAltButton,
    Dropdown,
    TolTypeAhead
  },

  directives: {
    clickOutside: vClickOutside.directive
  },
  data() {
    return {
      showSettingsDropdown: false
    };
  },

  computed: {
    activeInactive() {
      return this.$store.getters[ClientContactsListingGetters.ClientContactActiveInactive];
    },
    sortBy() {
      return this.$store.getters[ClientContactsListingGetters.ClientContactsListSortBy];
    },
    sortDirection() {
      return this.$store.getters[ClientContactsListingGetters.ClientContactsListSortDirection];
    },
    recordsPerPage() {
      return this.$store.getters[ClientContactsListingGetters.ClientContactsPerPage];
    },
    offSet() {
      return this.$store.getters[ClientContactsListingGetters.ClientContactsListingOffset];
    }
  },
  methods: {
    onExportChange(event) {
      this.$store.dispatch(ClientContactsListingActions.ExportContactsListExcel, event.menuOption);
    },
    toggleDropdown() {
      this.showSettingsDropdown = !this.showSettingsDropdown;
    },
    onFiltered(results) {
      results.data.map(contacts => {
        contacts.clientContactName = contacts.last_name + ',' + contacts.first_name;
        contacts.client = contacts.name;
      });
      this.$store.dispatch(ClientContactsListingActions.UpdateSearchList, results);
    }
  }
};
</script>

<style lang="scss" scoped>
@import '../../../../../styles/colors.scss';
@import '../../../../../styles/variables.scss';

.client-contact-actions {
  display: flex;
  background-color: $background-level-2;
  padding: 60px;

  .listing-title {
    color: $text-color-dark;
    font-size: 24px;
    font-weight: bold;
    letter-spacing: -0.24px;
    line-height: 28px;
    flex-basis: 25%;
  }

  .export {
    display: flex;
    position: relative;
    justify-content: flex-end;
    flex-basis: 25%;
    a,
    a.wrappeer {
      text-decoration: none;
      color: inherit;
    }
    .wrapper {
      margin-right: 3px;
    }
  }

  .search {
    margin-left: auto;
    display: flex;
    flex-basis: 50%;
    .search-container {
      flex: 1;
      margin-right: 3px;
    }
  }
}
</style>
